<script>
import axios from 'axios';
import router from '@/router';
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import Swal from 'sweetalert2';
import { authFackMethods } from '@/state/helpers';
export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { Header, Footer },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			submitData: {
				user_type_id: '',
				status: 'applicant',
			},
			profileDetailsLoaded: false,
			contactInfoForm: {
				username: '',
				status: null,
				avatar: '',
				t_shirt: '',
				email: '',
				address: '',
				phone: '',
				city: '',
				state: '',
				zip_code: '',
				age: '',
				gender: '',
				DOB: '',
				address2: '',
				mobile: '',
			},
			userTypeId: null,
			userName: null,
			userId: null,
			status: [
				{ value: '1', text: 'Active' },
				{ value: '0', text: 'InActive' },
				{ value: '2', text: 'Not A Fit' },
				{ value: '3', text: 'Not 2 Years Sober' },
				{ value: '4', text: 'Do Not Contact' },
				{ value: '5', text: 'Final Incomplete / Expired' },
				{ value: '6', text: 'DHS Not Approved Final' },
			],
			gender: [
				{ value: 'male', text: 'Male' },
				{ value: 'female', text: 'Female' },
			],

			userData: JSON.parse(localStorage.getItem('web_user')),
		};
	},
	mounted() {
		this.userId = this.userData.id;
		this.getContactDetail();
	},
	methods: {
		...authFackMethods,
		updateContactInfo() {
			var token = this.userData.token;
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
				},
			};
			if (token) {
				axios
					.post('user/applicant/profile/' + this.userId, this.contactInfoForm, config)
					.then((res) => {
						if (res) {
							Swal.fire({
								title: 'Success!',
								text: 'Contact Info Updated Successfully',
								icon: 'success',
								width: 350,
								showConfirmButton: true,
							});
							this.getContactDetail();
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err?.response?.data?.error?.message);
						}
					});
			}
		},

		async getContactDetail() {
			let component = this;
			try {
				let token = component.userData.token;
				if (!token || !component.userId) {
					await Swal.fire({
						title: 'Error!',
						text: 'Invalid login',
						icon: 'error',
						width: 350,
						showConfirmButton: true,
					});
					component.logout();
					return;
				}

				let config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				axios
					.get('user/' + component.userId, config)
					.then(async (res) => {
						if (res.status == 200) {
							component.contactInfoForm = res.data.response;
							component.userName = component.contactInfoForm.username;
							component.profileDetailsLoaded = true;
						}
					})
					.catch(async (err) => {
						if (err.response) {
							await Swal.fire({
								title: 'Error!',
								text: err?.response?.data?.error?.message || 'Something went wrong',
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
						}

						component.logout();
					});
			} catch (error) {
				Swal.fire({
					title: 'Error!',
					text: error?.message || 'Something went wrong',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});

				component.logout();
			}
		},
		calculateAge(DOB) {
			var today = new Date();
			var birthDate = new Date(DOB);
			var age = today.getFullYear() - birthDate.getFullYear();
			var m = today.getMonth() - birthDate.getMonth();
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--;
			}
			return age;
		},
		maybeGotoRoute(routeName) {
			const component = this;
			if (!routeName) {
				return;
			}
			if (component.$route.name == routeName) {
				return;
			}
			router.push({ name: routeName });
		},
		gotoRoles() {
			const component = this;
			component.maybeGotoRoute('volunteer-roles');
		},
		gotoMentorHours() {
			const component = this;
			component.maybeGotoRoute('mentor-hours');
		},
		loginPage() {
			const component = this;
			component.maybeGotoRoute('login');
		},
		gotoProfile() {
			const component = this;
			component.maybeGotoRoute('profile');
		},
		gotoApplication() {
			const component = this;
			component.maybeGotoRoute('review-application');
		},
		gotoBackgroundCheck() {
			const component = this;
			component.maybeGotoRoute('mentor-background-check');
		},
		gotoProfileUpdate() {
			const component = this;
			component.maybeGotoRoute('profile-update');
		},
		getFullName(user) {
			let fullname = '';
			if (user.first_name && user.first_name.length) {
				fullname += user.first_name;
			}
			if (user.last_name && user.last_name.length) {
				fullname += ' ' + user.last_name;
			}
			return fullname;
		},
	},
};
</script>

<template>
	<div>
		<Header></Header>
		<div id="main-title" class="secondary">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-6 align-self-center">
						<h3 class="title">Profile Information</h3>
					</div>
					<div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
						<p class="need-help">Need Help ? <a href="javascript:">Contact Us</a></p>
					</div>
				</div>
			</div>
		</div>

		<div class="custom-form d-flex container pb-5 pt-5">
			<b-button class="btn-custom ms-0" variant="custom" @click="gotoProfile"> Profile Information </b-button>
			<b-button v-if="userData['user_type_id'] === 4" class="btn-custom" variant="custom" @click="gotoRoles"> Roles </b-button>
			<b-button v-if="userData['user_type_id'] === 3 || (userData['user_type_id'] === 4 && userData['is_upgraded'] === 1)" class="btn-custom" variant="custom" @click="gotoMentorHours"> Mentor Hours </b-button>
			<b-button class="btn-custom" variant="custom" v-if="profileDetailsLoaded && contactInfoForm.status !== 1" @click="gotoApplication"> Review Application </b-button>
		</div>
		<!-- main content -->
		<div class="card custom-form pt-5 pb-5 container" v-if="userId">
			<div class="card-body">
				<div class="row">
					<div class="col-12">
						<template>
							<span class="d-inline-block d-sm-none">
								<i class="fas fa-home"></i>
							</span>
							<span class="d-none d-sm-inline-block">Profile</span>
						</template>

						<div class="row mb-4">
							<div class="col-lg-6">
								<div class="media">
									<div class="me-3" v-if="contactInfoForm">
										<div class="img-wrap">
											<img v-if="contactInfoForm.avatar !== null" class="img-thumbnail" :src="contactInfoForm.avatar" :alt="contactInfoForm ? contactInfoForm.username : 'N?A'" />
											<img v-else class="avatar-xl img-thumbnail" src="@/assets/images/no-image.png" :alt="contactInfoForm ? contactInfoForm.username : 'N?A'" />
										</div>
									</div>
									<div class="media-body align-self-center">
										<div class="text-muted">
											<span class="d-inline-block me-2 fw-bold">Status:</span>
											<span v-if="contactInfoForm.status == '1'" class="d-inline-block mb-1 me-1 text-success">Active</span>
											<span v-else-if="contactInfoForm.status == '0'" class="d-inline-block mb-1 me-1 text-danger">InActive</span>
											<span v-else-if="contactInfoForm.status == '2'" class="d-inline-block mb-1 me-1 text-danger">Not A Fit</span>
											<span v-else-if="contactInfoForm.status == '3'" class="d-inline-block mb-1 me-1 text-danger">Not 2 Years Sober</span>
											<span v-else-if="contactInfoForm.status == '4'" class="d-inline-block mb-1 me-1 text-danger">Do Not Contact</span>
											<span v-else-if="contactInfoForm.status == '5'" class="d-inline-block mb-1 me-1 text-danger">Final Incomplete / Expired</span>
											<span v-else-if="contactInfoForm.status == '6'" class="d-inline-block mb-1 me-1 text-danger">DHS Not Approved Final</span>
											<span v-else class="d-inline-block mb-1 me-1 text-danger">N/A</span>
											<br />
											<span class="d-inline-block me-2 fw-bold">User Name:</span>
											<h5 class="mb-1 me-1 d-inline-block">{{ getFullName(contactInfoForm) }}</h5>
											<p class="mb-1">
												<span class="d-inline-block me-2 fw-bold">Active Date:</span>
												<span class="d-inline-block me-2">{{ contactInfoForm.application_date }}</span>
												<i title="Date" class="bx bx-calendar"></i>
											</p>
										</div>
									</div>
								</div>
							</div>

							<div class="col-lg-2"></div>
							<div class="col-lg-4 roles-boxes">
								<div>
									<div v-if="contactInfoForm.UserType == 'Mentor'" class="box mentor bg-body">Mentor</div>
									<div v-if="contactInfoForm.UserType == 'Donor'" class="box donor bg-body">Donor</div>
									<div v-if="contactInfoForm.UserType == 'Program Alum'" class="box p-alum bg-body">Program Alum</div>
									<div v-if="contactInfoForm.UserType == 'Volunteer'" class="box volunteer bg-body">Volunteer</div>
								</div>
								<div v-if="contactInfoForm.user_type_id == 4 && contactInfoForm.is_invited == 1 && contactInfoForm.is_upgraded == 0 && contactInfoForm.is_applied == 0">
									<button type="button" @click="gotoBackgroundCheck" class="w-100 btn btn-primary mt-3">
										<i class="bx bxs-paper-plane font-size-18 align-middle me-1"></i>
										Become a Mentor
									</button>
								</div>
							</div>
						</div>

						<div class="row mt-5">
							<div class="col-12">
								<h4 class="mb-5">Contact Information</h4>
							</div>

							<div class="col-12 col-md-6 mb-3">
								<label>Address</label>
								<input type="text" v-model="contactInfoForm.address" class="form-control" placeholder="Enter Address" name="address" :disabled="!profileDetailsLoaded" />
							</div>

							<div class="col-12 col-md-6 mb-3">
								<label>Address 2</label>
								<input v-model="contactInfoForm.address2" type="text" class="form-control" placeholder="Enter Address (Optional)" name="address2" :disabled="!profileDetailsLoaded" />
							</div>

							<div class="col-12 col-md-6 mb-3">
								<label>City</label>
								<input v-model="contactInfoForm.city" type="text" class="form-control" placeholder="Enter City" name="city" :disabled="!profileDetailsLoaded" />
							</div>

							<div class="col-12 col-md-6 mb-3">
								<label>State</label>
								<input v-model="contactInfoForm.state" type="text" class="form-control" placeholder="Enter State" name="state" :disabled="!profileDetailsLoaded" />
							</div>

							<div class="col-12 col-md-6 mb-3">
								<label>Zip Code</label>
								<input type="text" v-model="contactInfoForm.zip_code" class="form-control" placeholder="Enter Zip Code" name="zip_code" :disabled="!profileDetailsLoaded" />
							</div>

							<div class="col-12 col-md-6 mb-3">
								<label>Email Address</label>
								<input type="text" :value="contactInfoForm.email" class="form-control" name="email" disabled readonly />
							</div>

							<div class="col-12 col-md-6 mb-3">
								<label>Phone Number</label>
								<input type="text" v-model="contactInfoForm.phone" class="form-control" placeholder="Enter Phone Number" name="phone" :disabled="!profileDetailsLoaded" />
							</div>

							<div class="col-12 col-md-6 mb-3">
								<label>Alternate Number</label>
								<input type="text" v-model="contactInfoForm.mobile" class="form-control" placeholder="Enter Alternate Number" name="mobile" :disabled="!profileDetailsLoaded" />
							</div>

							<div class="col-12 px-5">
								<hr />
							</div>

							<div class="col-12 mb-3 text-center">
								<b-button @click="updateContactInfo" class="btn-custom" variant="primary" title="Update User" :disabled="!profileDetailsLoaded"> Update User </b-button>
							</div>

							<div class="col-12">
								<p style="text-align: center">
									<a @click="gotoProfileUpdate" style="text-decoration: underline" href="javascript:;" class="small">Request profile information update</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="custom-form" v-else>
			<div class="text-center mt-3">
				<b-button class="btn-custom" variant="custom" @click="loginPage"> Login </b-button>
			</div>
		</div>

		<Footer></Footer>
	</div>
</template>
<style scoped>
.custom-form label {
	font-size: 16px;
	margin-left: 16px;
}
.media:hover .edit-box {
	position: absolute;
	top: 0px;
	bottom: 0px;
	left: 0px;
	right: 0px;
	visibility: visible;
	opacity: 1;
}
.media .edit-box {
	visibility: hidden;
	opacity: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgb(0 0 0 / 0.08);
}
.roles-boxes {
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.box {
	padding: 5px;
	text-align: center;
}
.box.mentor {
	border: 2px solid #556ee6;
}
.box.donor {
	border: 2px solid #34c38f;
}
.box.p-alum {
	border: 2px solid #50a5f1;
}
.box.volunteer {
	border: 2px solid #f1b44c;
}
.chck-icon {
	font-size: 130px;
}
.pb-1-5rem {
	padding-bottom: 1.5rem !important;
}
.avatar-box {
	width: 30%;
	overflow: hidden;
	margin: 0 auto;
}
.img-wrap {
	height: 7.5rem;
	width: 7.5rem;
	position: relative;
	border: 2px solid #f6f6f6;
	border-radius: 100%;
	overflow: hidden;
}
.img-wrap img {
	width: 100%;
	position: absolute;
	left: 0px;
	right: 0px;
	top: 50%;
	transform: translateY(-50%);
}
.preview {
	position: relative;
}
.preview img {
	width: 100%;
}
.btn-remove {
	background-color: #ebecec;
	position: absolute;
	top: -15px;
	right: -15px;
	padding: 0px;
	font-size: 24px;
	border-radius: 100%;
	width: 30px;
	height: 30px;
	line-height: 30px;
	-webkit-box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
	box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
}
</style>
